import { render, staticRenderFns } from "./o-sidebar.vue?vue&type=template&id=730e8e6a&scoped=true&lang=pug"
import script from "./o-sidebar.vue?vue&type=script&lang=js"
export * from "./o-sidebar.vue?vue&type=script&lang=js"
import style0 from "./o-sidebar.vue?vue&type=style&index=0&id=730e8e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730e8e6a",
  null
  
)

export default component.exports